/**
 * InProgressEmptyWarning — coral banner rendered on the In Progress
 * column when the slot is empty but Submitted or Paused has files
 * waiting (CLAUDE.md §7.6).
 *
 * Derived view of pipeline state — not a flag set by an action.
 * Renders whenever In Progress is empty AND (Submitted has any files
 * OR Paused has any files). Disappears the moment In Progress has a
 * file. Same component is used on both the Adviser and Assistant
 * dashboards.
 */

import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';

export default function InProgressEmptyWarning() {
  return (
    <motion.div
      style={styles.banner}
      initial={{ opacity: 0, y: -6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25 }}
      role="status"
      aria-live="polite"
    >
      <AlertTriangle size={14} color="#E76F51" />
      <span style={styles.text}>
        No active file — draw a file from Inbox to continue.
      </span>
    </motion.div>
  );
}

const styles = {
  banner: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '0.4rem',
    padding: '0.55rem 0.7rem',
    background: 'rgba(231, 111, 81, 0.10)',
    border: '1px solid rgba(231, 111, 81, 0.35)',
    borderRadius: '10px',
    fontSize: '0.78rem',
    lineHeight: 1.35,
    color: '#A8421F',
    fontWeight: 500,
  },
  text: {
    flex: 1,
    minWidth: 0,
  },
};
